var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppstoreAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 203 60",
    width: 203,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "91.536%",
    x2: "-37.559%",
    y1: "37.788%",
    y2: "55.94%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "107.728%",
    x2: "-130.665%",
    y1: "49.428%",
    y2: "49.428%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#ffa500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "71.674%",
    x2: "-9.496%",
    y1: "17.815%",
    y2: "194.393%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "9.531%",
    x2: "45.441%",
    y1: "-54.527%",
    y2: "24.69%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m195.481481 60h-187.96296248c-4.21037037 0-7.51851852-3.3-7.51851852-7.5v-45c0-4.2 3.30814815-7.5 7.51851852-7.5h187.96296248c4.210371 0 7.518519 3.3 7.518519 7.5v45c0 4.05-3.308148 7.5-7.518519 7.5z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.481481 1.2c3.458519 0 6.315556 2.85 6.315556 6.3v45c0 3.45-2.857037 6.3-6.315556 6.3h-187.96296248c-3.45851852 0-6.31555556-2.85-6.31555556-6.3v-45c0-3.45 2.85703704-6.3 6.31555556-6.3zm0-1.2h-187.96296248c-4.21037037 0-7.51851852 3.3-7.51851852 7.5v45c0 4.2 3.30814815 7.5 7.51851852 7.5h187.96296248c4.210371 0 7.518519-3.3 7.518519-7.5v-45c0-4.05-3.308148-7.5-7.518519-7.5z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.2755556 15.3c0 1.2-.3007408 2.25-1.0525926 3-.9022223.9-1.9548149 1.35-3.3081482 1.35s-2.4059259-.45-3.3081481-1.35c-.9022223-.9-1.3533334-1.95-1.3533334-3.3s.4511111-2.4 1.3533334-3.3c.9022222-.9 1.9548148-1.35 3.3081481-1.35.6014815 0 1.202963.15 1.8044445.45.6014814.3 1.0525926.6 1.3533333 1.05l-.7518519.75c-.6014814-.75-1.3533333-1.05-2.4059259-1.05-.9022222 0-1.8044444.3-2.4059259 1.05-.7518519.6-1.0525926 1.5-1.0525926 2.55s.3007407 1.95 1.0525926 2.55c.7518518.6 1.5037037 1.05 2.4059259 1.05 1.0525926 0 1.8044445-.3 2.5562963-1.05.4511111-.45.7518519-1.05.7518519-1.8h-3.3081482v-1.05h4.3607408zm6.917037-3.75h-4.06v2.85h3.7592593v1.05h-3.7592593v2.85h4.06v1.2h-5.262963v-9h5.262963zm4.9622222 7.95h-1.2029629v-7.95h-2.5562963v-1.05h6.3155555v1.05h-2.5562963zm6.9170371 0v-9h1.2029629v9zm6.3155555 0h-1.202963v-7.95h-2.5562963v-1.05h6.1651852v1.05h-2.5562963v7.95zm14.2851856-1.2c-.902223.9-1.954815 1.35-3.308149 1.35-1.353333 0-2.405925-.45-3.308148-1.35-.902222-.9-1.353333-1.95-1.353333-3.3s.451111-2.4 1.353333-3.3c.902223-.9 1.954815-1.35 3.308148-1.35 1.353334 0 2.405926.45 3.308149 1.35.902222.9 1.353333 1.95 1.353333 3.3s-.451111 2.4-1.353333 3.3zm-5.714074-.75c.601481.6 1.503703 1.05 2.405925 1.05.902223 0 1.804445-.3 2.405926-1.05.601482-.6 1.052593-1.5 1.052593-2.55s-.300741-1.95-1.052593-2.55c-.601481-.6-1.503703-1.05-2.405926-1.05-.902222 0-1.804444.3-2.405925 1.05-.601482.6-1.052593 1.5-1.052593 2.55s.300741 1.95 1.052593 2.55zm8.721481 1.95v-9h1.353333l4.360741 7.05v-7.05h1.202963v9h-1.202963l-4.661481-7.35v7.35z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.402222 32.7c-3.6088887 0-6.4659257 2.7-6.4659257 6.45 0 3.6 2.857037 6.45 6.4659257 6.45 3.608889 0 6.465926-2.7 6.465926-6.45 0-3.9-2.857037-6.45-6.465926-6.45zm0 10.2c-1.954815 0-3.6088887-1.65-3.6088887-3.9s1.6540737-3.9 3.6088887-3.9 3.608889 1.5 3.608889 3.9c0 2.25-1.654074 3.9-3.608889 3.9zm-13.9844442-10.2c-3.6088889 0-6.4659259 2.7-6.4659259 6.45 0 3.6 2.857037 6.45 6.4659259 6.45s6.4659259-2.7 6.4659259-6.45c0-3.9-2.857037-6.45-6.4659259-6.45zm0 10.2c-1.9548148 0-3.6088889-1.65-3.6088889-3.9s1.6540741-3.9 3.6088889-3.9 3.6088889 1.5 3.6088889 3.9c0 2.25-1.6540741 3.9-3.6088889 3.9zm-16.6911111-8.25v2.7h6.4659259c-.1503704 1.5-.7518519 2.7-1.5037037 3.45-.9022222.9-2.4059259 1.95-4.9622222 1.95-4.06 0-7.0674074-3.15-7.0674074-7.2s3.1577777-7.2 7.0674074-7.2c2.1051852 0 3.7592592.9 4.9622222 1.95l1.9548148-1.95c-1.6540741-1.5-3.7592593-2.7-6.7666667-2.7-5.4133333 0-10.0748148 4.5-10.0748148 9.9s4.6614815 9.9 10.0748148 9.9c3.0074074 0 5.1125926-.9 6.9170371-2.85 1.8044444-1.8 2.4059259-4.35 2.4059259-6.3 0-.6 0-1.2-.1503704-1.65zm68.2681483 2.1c-.601482-1.5-2.105185-4.05-5.413334-4.05-3.308148 0-6.014814 2.55-6.014814 6.45 0 3.6 2.706666 6.45 6.315555 6.45 2.857037 0 4.661482-1.8 5.262963-2.85l-2.105185-1.5c-.751852 1.05-1.654074 1.8-3.157778 1.8-1.503703 0-2.405926-.6-3.157778-1.95l8.571112-3.6zm-8.721482 2.1c0-2.4 1.954815-3.75 3.308148-3.75 1.052593 0 2.105186.6 2.405926 1.35zm-7.067407 6.15h2.857037v-18.75h-2.857037zm-4.511111-10.95c-.751852-.75-1.954815-1.5-3.458519-1.5-3.157777 0-6.165185 2.85-6.165185 6.45s2.857037 6.3 6.165185 6.3c1.503704 0 2.706667-.75 3.308148-1.5h.150371v.9c0 2.4-1.353334 3.75-3.458519 3.75-1.654074 0-2.857037-1.2-3.157777-2.25l-2.405926 1.05c.751851 1.65 2.556296 3.75 5.714074 3.75 3.308148 0 6.014814-1.95 6.014814-6.6v-11.4h-2.706666zm-3.308148 8.85c-1.954815 0-3.608889-1.65-3.608889-3.9s1.654074-3.9 3.608889-3.9c1.954814 0 3.458518 1.65 3.458518 3.9s-1.503704 3.9-3.458518 3.9zm36.69037-16.65h-6.766667v18.75h2.857037v-7.05h3.90963c3.157778 0 6.165185-2.25 6.165185-5.85s-3.007407-5.85-6.165185-5.85zm.15037 9h-4.06v-6.45h4.06c2.105186 0 3.308149 1.8 3.308149 3.15-.150371 1.65-1.353334 3.3-3.308149 3.3zm17.292593-2.7c-2.105185 0-4.21037.9-4.962222 2.85l2.556296 1.05c.601482-1.05 1.503704-1.35 2.556296-1.35 1.503704 0 2.857037.9 3.007408 2.4v.15c-.451111-.3-1.654074-.75-2.857037-.75-2.706667 0-5.413334 1.5-5.413334 4.2 0 2.55 2.255556 4.2 4.661482 4.2 1.954815 0 2.857037-.9 3.608889-1.8h.15037v1.5h2.706667v-7.2c-.300741-3.3-2.857037-5.25-6.014815-5.25zm-.300741 10.35c-.902222 0-2.255555-.45-2.255555-1.65 0-1.5 1.654074-1.95 3.007407-1.95 1.202963 0 1.804445.3 2.556296.6-.30074 1.8-1.804444 3-3.308148 3zm15.788889-9.9-3.157778 8.1h-.15037l-3.308148-8.1h-3.007408l4.962223 11.4-2.857037 6.3h2.857037l7.668889-17.7zm-25.262222 12h2.857037v-18.75h-2.857037z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.6385185 11.25c-.4511111.45-.7518518 1.2-.7518518 2.1v33.15c0 .9.3007407 1.65.7518518 2.1l.1503704.15 18.6459259-18.6v-.3z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.6 36.45-6.1651852-6.15v-.45l6.1651852-6.15.1503704.15 7.3681481 4.2c2.1051852 1.2 2.1051852 3.15 0 4.35z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.7503704 36.3-6.3155556-6.3-18.7962963 18.75c.7518519.75 1.8044445.75 3.1577778.15z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.7503704 23.7-21.9540741-12.45c-1.3533333-.75-2.4059259-.6-3.1577778.15l18.7962963 18.6z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.6 36.15-21.8037037 12.3c-1.202963.75-2.2555556.6-3.0074074 0l-.1503704.15.1503704.15c.7518518.6 1.8044444.75 3.0074074 0z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.6385185 48.45c-.4511111-.45-.6014815-1.2-.6014815-2.1v.15c0 .9.3007408 1.65.7518519 2.1v-.15zm32.48-16.5-7.5185185 4.2.1503704.15 7.3681481-4.2c1.0525926-.6 1.5037037-1.35 1.5037037-2.1 0 .75-.6014815 1.35-1.5037037 1.95z",
    fill: "#000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.7962963 11.4 29.3222222 16.65c.9022222.6 1.5037037 1.2 1.5037037 1.95 0-.75-.4511111-1.5-1.5037037-2.1l-29.3222222-16.65c-2.1051852-1.2-3.7592593-.15-3.7592593 2.25v.15c0-2.4 1.6540741-3.45 3.7592593-2.25z",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreAndroid);
export default __webpack_public_path__ + "static/media/appstore-android.970117b50dbcd82c9131f74b18c2ea82.svg";
export { ForwardRef as ReactComponent };